<template>
  <div class="list smart-hr-roster">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>智能人事</Breadcrumb-item>
        <Breadcrumb-item>员工管理</Breadcrumb-item>
        <Breadcrumb-item>花名册</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Alert type="warning" show-icon class="tip">
      数据从钉钉同步到本后台；在本后台新增/修改/导入导出不会写回钉钉。
    </Alert>
    <div class="search">
      <Form :label-width="70" :show-message="false" inline>
        <Form-item label="状态">
          <Select v-model="query.empStatus" style="width:140px;" clearable @on-change="search">
            <Option value="ACTIVE">在职</Option>
            <Option value="DIMISSION">已离职</Option>
            <Option value="PREHIRE">待入职</Option>
          </Select>
        </Form-item>
        <Form-item label="关键字">
          <Input v-model="query.keyword" placeholder="姓名/手机/工号/钉钉ID" style="width:220px;" @on-enter="search"/>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="search">查询</Button>
          <Button style="margin-left:8px;" @click="reset">重置</Button>
        </Form-item>
      </Form>
    </div>
    <div class="btn-wrap">
      <div class="left-btn">
        <Button type="primary" :loading="syncing" @click="doSync">从钉钉同步</Button>
        <Button style="margin-left:8px;" type="success" @click="openAdd">本地新增</Button>
      </div>
      <div class="right-btn">
        <Button @click="doTemplate" :loading="tplLoading">下载导入模板</Button>
        <Upload
          :before-upload="beforeImport"
          :show-upload-list="false"
          action=""
          accept=".xlsx,.xls"
          style="display:inline-block;margin-left:8px;">
          <Button :loading="importing">导入（仅本地）</Button>
        </Upload>
        <Button style="margin-left:8px;" type="primary" :loading="exportLoading" @click="doExport">导出</Button>
      </div>
    </div>
    <div v-if="syncMsg" class="sync-msg">{{ syncMsg }}</div>
    <Table :columns="columns" :data="rows" :loading="loading" stripe no-data-text="暂无员工，请先从钉钉同步"></Table>
    <div class="pager">
      <Page :total="total" :current="query.pageIndex" :page-size="query.pageSize"
            show-total show-sizer @on-change="onPage" @on-page-size-change="onSize"/>
    </div>

    <Modal v-model="drawer" title="员工详情" :mask-closable="false" width="640" :footer-hide="true">
      <div v-if="detail">
        <Form :label-width="90">
          <Form-item label="姓名"><Input v-model="edit.name"/></Form-item>
          <Form-item label="手机"><Input v-model="edit.mobile"/></Form-item>
          <Form-item label="工号"><Input v-model="edit.jobNumber"/></Form-item>
          <Form-item label="职位"><Input v-model="edit.position"/></Form-item>
          <Form-item label="部门"><Input v-model="edit.deptNames"/></Form-item>
          <Form-item label="状态">
            <Select v-model="edit.empStatus">
              <Option value="ACTIVE">在职</Option>
              <Option value="DIMISSION">已离职</Option>
              <Option value="PREHIRE">待入职</Option>
            </Select>
          </Form-item>
          <Form-item label="来源">
            <span>{{ edit.source === 'LOCAL' || edit.localDirty === 1 ? '本地维护' : '钉钉同步' }}</span>
          </Form-item>
        </Form>
        <div style="margin-top:16px;">
          <Button type="primary" :loading="saving" @click="saveLocal">保存（仅本地）</Button>
          <Button style="margin-left:8px;" @click="drawer=false">关闭</Button>
        </div>
        <Divider>花名册字段</Divider>
        <div v-if="!(detail.fields && detail.fields.length)" style="color:#999;">暂无字段数据</div>
        <Table v-else size="small" :columns="fieldColumns" :data="detail.fields"></Table>
      </div>
    </Modal>

    <Modal v-model="showAdd" title="本地新增员工（不写回钉钉）" @on-ok="addLocal">
      <Form :label-width="90">
        <Form-item label="姓名" required><Input v-model="addForm.name"/></Form-item>
        <Form-item label="手机"><Input v-model="addForm.mobile"/></Form-item>
        <Form-item label="工号"><Input v-model="addForm.jobNumber"/></Form-item>
        <Form-item label="职位"><Input v-model="addForm.position"/></Form-item>
        <Form-item label="部门"><Input v-model="addForm.deptNames"/></Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'SmartHrRoster',
  data () {
    return {
      loading: false,
      syncing: false,
      saving: false,
      importing: false,
      exportLoading: false,
      tplLoading: false,
      showAdd: false,
      syncMsg: '',
      addForm: { name: '', mobile: '', jobNumber: '', position: '', deptNames: '' },
      rows: [],
      total: 0,
      query: { pageIndex: 1, pageSize: 20, empStatus: 'ACTIVE', keyword: '' },
      drawer: false,
      detail: null,
      edit: {},
      columns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '姓名', key: 'name', minWidth: 140,
          render: (h, { row }) => {
            const badge = (row.localDirty === 1 || row.source === 'LOCAL')
              ? h('span', { class: 'badge-local' }, '本地维护')
              : h('span', { class: 'badge-ding' }, '钉钉同步')
            return h('span', [row.name || '-', ' ', badge])
          }
        },
        { title: '手机', key: 'mobile', minWidth: 120 },
        { title: '工号', key: 'jobNumber', minWidth: 100 },
        { title: '部门', key: 'deptNames', minWidth: 140 },
        { title: '职位', key: 'position', minWidth: 120 },
        { title: '钉钉userId', key: 'dingUserId', minWidth: 140 },
        { title: '状态', key: 'empStatus', width: 90,
          render: (h, { row }) => h('span', this.statusText(row.empStatus)) },
        { title: '操作', width: 90, fixed: 'right',
          render: (h, { row }) => h('a', { on: { click: () => this.openDetail(row.id) } }, '详情') }
      ],
      fieldColumns: [
        { title: '分组', key: 'groupId', width: 100 },
        { title: '字段', key: 'fieldName', minWidth: 120 },
        { title: '值', key: 'labelValue', minWidth: 160 }
      ]
    }
  },
  created () { this.load() },
  methods: {
    stripReadonlyTimes (obj) {
      if (!obj || typeof obj !== 'object') return obj
      const payload = Object.assign({}, obj)
      delete payload.gmtCreate
      delete payload.gmtModified
      delete payload.syncedAt
      return payload
    },
    statusText (s) {
      if (s === 'ACTIVE') return '在职'
      if (s === 'DIMISSION') return '已离职'
      if (s === 'PREHIRE') return '待入职'
      return s || '-'
    },
    search () { this.query.pageIndex = 1; this.load() },
    reset () {
      this.query = { pageIndex: 1, pageSize: 20, empStatus: 'ACTIVE', keyword: '' }
      this.load()
    },
    onPage (p) { this.query.pageIndex = p; this.load() },
    onSize (s) { this.query.pageSize = s; this.query.pageIndex = 1; this.load() },
    load () {
      this.loading = true
      this.$http.post('/smartHr/roster/page', this.query).then(res => {
        if (res && res.status === 'ok' && res.data) {
          this.rows = res.data.data || []
          this.total = res.data.totalCount || 0
        }
      }).finally(() => { this.loading = false })
    },
    doSync () {
      this.syncing = true
      this.syncMsg = ''
      this.$http.post('/smartHr/sync', { scope: 'roster', mode: 'full' }).then(res => {
        if (res && res.status === 'ok') {
          this.syncMsg = '同步完成'
          this.$Message.success('同步完成')
          this.load()
        } else {
          this.syncMsg = (res && res.msg) || '同步失败'
        }
      }).catch(err => {
        this.syncMsg = (err && err.message) || '同步失败'
      }).finally(() => { this.syncing = false })
    },
    openDetail (id) {
      this.$http.post('/smartHr/roster/detail', { id }).then(res => {
        if (res && res.status === 'ok' && res.data) {
          this.detail = res.data
          this.edit = Object.assign({}, res.data.employee || {})
          this.drawer = true
        }
      })
    },
    openAdd () {
      this.addForm = { name: '', mobile: '', jobNumber: '', position: '', deptNames: '' }
      this.showAdd = true
    },
    addLocal () {
      if (!this.addForm.name) {
        this.$Message.warning('姓名必填')
        return
      }
      this.$http.post('/smartHr/roster/add', this.stripReadonlyTimes(Object.assign({ empStatus: 'ACTIVE' }, this.addForm))).then(res => {
        if (res && res.status === 'ok') {
          this.$Message.success('已本地新增')
          this.showAdd = false
          this.load()
        }
      })
    },
    downloadBlob (response, filename) {
      if (!response || !response.data) {
        this.$Message.error('下载失败：无文件内容')
        return
      }
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    doExport () {
      this.exportLoading = true
      this.$http.post('/smartHr/roster/export', this.query, { responseType: 'arraybuffer' }).then(response => {
        this.downloadBlob(response, 'smart-hr-roster.xlsx')
      }).catch(() => {
        this.$Message.error('导出失败')
      }).finally(() => { this.exportLoading = false })
    },
    doTemplate () {
      this.tplLoading = true
      this.$http.post('/smartHr/roster/importTemplate', {}, { responseType: 'arraybuffer' }).then(response => {
        this.downloadBlob(response, '钉钉智能人事花名册模板.xlsx')
        this.$Message.success('模板已下载')
      }).catch(() => {
        this.$Message.error('下载导入模板失败')
      }).finally(() => { this.tplLoading = false })
    },
    beforeImport (file) {
      const fd = new FormData()
      fd.append('file', file)
      this.importing = true
      this.$http.post('/smartHr/roster/import', fd).then(res => {
        if (res && res.status === 'ok') {
          const n = (res.data && res.data.imported) || 0
          this.$Message.success('已导入 ' + n + ' 条（仅本地）')
          this.load()
        }
      }).finally(() => { this.importing = false })
      return false
    },
    saveLocal () {
      this.saving = true
      const payload = this.stripReadonlyTimes(this.edit)
      this.$http.post('/smartHr/roster/update', payload).then(res => {
        if (res && res.status === 'ok') {
          this.$Message.success('已保存到本地')
          this.drawer = false
          this.load()
        }
      }).finally(() => { this.saving = false })
    }
  }
}
</script>
<style lang="less" scoped>
.tip { margin-bottom: 12px; }
.sync-msg { margin: 0 0 10px; color: #2d8cf0; }
.btn-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0 12px;
  clear: both;
}
.left-btn, .right-btn {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.pager {
  margin-top: 12px;
  text-align: right;
}
.badge-ding { color: #2d8cf0; margin-left: 6px; font-size: 12px; }
.badge-local { color: #ff9900; margin-left: 6px; font-size: 12px; }
</style>



// WEBPACK FOOTER //
// SmartHrRoster.vue?327da107